import { createAction, props } from '@ngrx/store';
import { CreateStationDto, StationComponentDto, StationDto, UpdateStationDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';

// Read list
export const readStations = createAction('@app/station/read', (query?: PaginatedListQuery) => ({ query }));
export const readStationsSuccess = createAction('@app/station/read/success', props<{ stations: StationDto[]; total: number }>());
export const readStationsFailure = createAction('@app/station/read/failure', props<{ error: any }>());

// Read single (detail) — resolves from the loaded list by id, falling back to a
// server fetch (readOne) so a reload/deep-link always has the full, fresh detail.
export const readStation = createAction('@app/station/read-one', props<{ stationId: number }>());
export const readStationSuccess = createAction('@app/station/read-one/success', props<{ station: StationDto }>());
export const readStationFailure = createAction('@app/station/read-one/failure', props<{ error: any }>());

// Create
export const createStation = createAction('@app/station/create', props<{ dto: CreateStationDto }>());
export const createStationSuccess = createAction('@app/station/create/success', props<{ station: StationDto }>());
export const createStationFailure = createAction('@app/station/create/failure', props<{ error: any }>());

// Update
export const updateStation = createAction('@app/station/update', props<{ stationId: number; dto: UpdateStationDto }>());
export const updateStationSuccess = createAction('@app/station/update/success', props<{ station: Partial<StationDto> }>());
export const updateStationFailure = createAction('@app/station/update/failure', props<{ error: any }>());

// Delete
export const deleteStation = createAction('@app/station/delete', props<{ stationId: number }>());
export const deleteStationSuccess = createAction('@app/station/delete/success', props<{ station: StationDto }>());
export const deleteStationFailure = createAction('@app/station/delete/failure', props<{ error: any }>());

// Restore
export const restoreStation = createAction('@app/station/restore', props<{ stationId: number }>());
export const restoreStationSuccess = createAction('@app/station/restore/success', props<{ station: StationDto }>());
export const restoreStationFailure = createAction('@app/station/restore/failure', props<{ error: any }>());

// Load components
export const readStationComponents = createAction('@app/station/components/read');
export const readStationComponentsSuccess = createAction('@app/station/components/read/success', props<{ components: StationComponentDto[] }>());
export const readStationComponentsFailure = createAction('@app/station/components/read/failure', props<{ error: any }>());
